module.exports = __webpack_public_path__ + "media/1.70affa44.mp3";